import Gardener from 'scoreboard/components/gardener'
import _ from 'lodash'
import Finder from 'scoreboard/components/finder'
import regexEscape from 'escape-string-regexp'
import Backbone from 'backbone'
import paste from 'scoreboard/components/paste/paste'
import editButton from 'scoreboard/components/bottom-toolbar-edit-button.hbs'
import * as AddTypes from 'scoreboard/components/add-types'
import $ from 'jquery'
const { CHILD }  = AddTypes

/**
 * The gardener for dataset rollup trees.
 *
 * @extends Gardener
 */
var DatasetTreeGardener = Gardener.extend(/** @lends DatasetTreeGardener.prototype */{

	forest: false,

	nodeTransforms: [
		node => node.icon = 'rollup-item'
	],

	readyToStream: function() {
		return this.options.id
	},

	/**
	 * @override
	 */
	initializeFinder: function(options) {
		this.finder = new Finder(_.extend({ type: 'light' }, options.finderOptions))
		this.listenTo(this.finder, 'find', function(term) {
			if (_.isEmpty(term)) {
				this.tree.search()
				this.trigger('search')
				return
			}

			// regular expressions are faster than .indexOf it looks like
			// https://jsperf.com/regexp-vs-indexof-sgarlata (link expired though)
			var re = new RegExp(regexEscape(term), 'i')
			this.tree.filter(function(node) {
				// search the label
				if (re.test(node.label)) {
					return true
				}
				// search the keys
				return !!_.find(node.keys, function(keysByKeySetId) {
					return !!_.find(_.values(keysByKeySetId), function(key) {
						return re.test(key)
					})
				})
			})
		}.bind(this))
	},

	render: function() {
		Gardener.prototype.render.apply(this, arguments)
		if (this.options.editable) {
			// If the tree is editable, go ahead and insert the edit button so
			// we can use it to toggle edit mode on and off.
			this._renderBottomToolbarEditButton()
		}
	},

	_renderBottomToolbarEditButton: function() {
		this.$('.bottom-toolbar').addClass('nav-or-tree-toolbar nav-bottom-toolbar is-editable')
			.append(editButton())
		this.$('.edit').on('click', () => {
			this.tree.editable()
			let editable = this.tree.isEditable()
			this.$('.icon-edit, .nav-edit-text').toggleClass('is-not-displayed', editable)
			this.$('.icon-done, .nav-done-text').toggleClass('is-not-displayed', !editable)
		})
	},

	_url: function(opt) {
		let url = 'api/dataset-trees/' + opt.id + '/tree'
		let params = {}
		if (this.options.showKeys) {
			params.keys = true
		}
		// #63092 only sort the tree alphabetically if the sort option is set
		if (this.options.sortAlphabetically) {
			params.sortAlphabetically = true
		}
		let queryString = $.param(params)
		if (queryString) {
			url += '?' + queryString
		}
		return url
	},

	interested: function({domainType}) {
		return domainType === 'dataset-tree'
	},

	getAddType: function (relative, newItem) {
		// #7476 rule 4: If the selected item is a scorecard item, the new item is a child.
		// obviously this isn't a scorecard item, but the tree should behave the same way
		return CHILD
	},

	_treeOptions: function() {
		var gardener = this
		var treeOptions = Gardener.prototype._treeOptions.apply(this, arguments)
		treeOptions.droppable = _.constant(true)
		// draw the label for each item in the tree, which includes the keys at the
		// end in lighter gray
		treeOptions.label = function (selection) {
			var tree = this
			selection.html(function (d) {
				var node = tree.nodes[d.id]
				var label = _.escape(node.label)
				if (!_.isEmpty(node.keys) && gardener.options.showKeys) {
					const keyListing = _.chain(node.keys)
						.values()
						.filter(it => !!it && it.length)
						.join(', ')
						.escape()
						.value()
					label +=
						` <span class="keys">(${keyListing})</span>`
				}
				return label
			})
		}

		treeOptions.accessors = { icon: 'icon' }

		if (!_.isNil(this.options.initialSelection)) {
			// #26714 default gardener behavior is to prefer options.id instead of
			// options.initialSelection for choosing the intially selected tree item.
			// Instead, let's always use initialSelection if available
			treeOptions.initialSelection = this.options.initialSelection
		}

		return treeOptions
	},


	move: function(node, newParent, oldParent, newIndex, oldIndex) {
		paste({
			mode: 'move',
			url: 'api/dataset-trees/' + node.id,
			id: node.id,
			parentId: newParent && newParent.id,
			index: newIndex
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.finder], 'remove')
	}

})

export default DatasetTreeGardener

DatasetTreeGardener.__filename__ = 'datasets/dataset-tree-gardener.js'
